(function() {
  if (window.__prop65Initialized) return;
  window.__prop65Initialized = true;

  function closeOverlay(overlay) {
    overlay.classList.remove('is-open');
    const handleTransitionEnd = () => {
      overlay.style.display = 'none';
      overlay.removeEventListener('transitionend', handleTransitionEnd);
    };
    overlay.addEventListener('transitionend', handleTransitionEnd);
    document.body.style.overflow = '';
  }

  function printMessage(overlay) {
    const dialog = overlay.querySelector('.prop-65-warning__dialog');
    if (!dialog) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const titleText = dialog.querySelector('.prop-65-warning__title')?.innerText || 'CALIFORNIA WARNING';
    const msgText = dialog.querySelector('.prop-65-warning__message')?.innerHTML || '';
    const externalLinkWrap = dialog.querySelector('.prop-65-warning__link-wrap')?.innerHTML || '';

    const html = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Prop 65 Warning</title>
          <style>
            body { font-family: system-ui, -apple-system, sans-serif; padding: 40px; line-height: 1.6; text-align: center; color: #333; }
            .prop-65-warning__title { font-size: 24px; font-weight: bold; margin-bottom: 20px; text-transform: uppercase; color: #856404; }
            .prop-65-warning__message { font-size: 18px; margin-bottom: 20px; text-align: left; max-width: 600px; margin-left: auto; margin-right: auto; }
            .prop-65-warning__external { font-size: 16px; color: #007bff; text-decoration: none; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2 class="prop-65-warning__title">${titleText}</h2>
          <div class="prop-65-warning__message">${msgText}</div>
          <p>${externalLinkWrap}</p>
        </body>
      </html>
    `;
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    // Trigger browser print dialog
    setTimeout(function() {
      printWindow.print();
      printWindow.close();
    }, 250);
  }

  document.addEventListener('click', function(e) {
    // 1. Trigger button click
    const trigger = e.target.closest('.prop-65-trigger');
    if (trigger) {
      e.preventDefault();
      const targetId = trigger.getAttribute('data-target');
      const overlay = document.getElementById(targetId);
      if (overlay) {
        if (overlay.parentNode !== document.body) {
          document.body.appendChild(overlay);
        }
        overlay.style.display = 'grid';
        // Force reflow
        overlay.offsetHeight;
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    // 2. Close button click
    const closeBtn = e.target.closest('.prop-65-warning__close');
    if (closeBtn) {
      const overlay = closeBtn.closest('.prop-65-warning__overlay');
      if (overlay) {
        closeOverlay(overlay);
      }
      return;
    }

    // 3. Print button click
    const printBtn = e.target.closest('.prop-65-warning__print');
    if (printBtn) {
      const overlay = printBtn.closest('.prop-65-warning__overlay');
      if (overlay) {
        printMessage(overlay);
      }
      return;
    }

    // 4. Click outside overlay to close
    const overlay = e.target.closest('.prop-65-warning__overlay');
    if (overlay && e.target === overlay) {
      closeOverlay(overlay);
    }
  });

  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openOverlay = document.querySelector('.prop-65-warning__overlay.is-open');
      if (openOverlay) {
        closeOverlay(openOverlay);
      }
    }
  });
})();
